/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FieldInfo, WellLinkedDataType } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class FieldsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Fields
   * @summary Получение идентификаторов всех месторождений
   * @request GET:/geology/Fields
   * @secure
   */
  fieldsGetAllFieldIds = (params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Fields`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fields
   * @summary Получение информации о всех месторождениях
   * @request GET:/geology/Fields/all-data
   * @secure
   */
  fieldsGetAllFieldData = (params: RequestParams = {}) =>
    this.http.request<FieldInfo[], any>({
      path: `/geology/Fields/all-data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fields
   * @summary Получение информации о месторождениях со скважинными данными
   * @request GET:/geology/Fields/having/{linkedDataType}
   * @secure
   */
  fieldsGetFieldsHavingWellData = (
    linkedDataType: WellLinkedDataType,
    params: RequestParams = {},
  ) =>
    this.http.request<FieldInfo[], any>({
      path: `/geology/Fields/having/${linkedDataType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fields
   * @summary Получение идентификаторов месторождений, принадлежащих ДО
   * @request GET:/geology/Fields/for_company/{companyId}
   * @secure
   */
  fieldsGetFieldIdsForCompany = (companyId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Fields/for_company/${companyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fields
   * @summary Получение информации о всех месторождений, принадлежащих ДО
   * @request GET:/geology/Fields/for_company/{companyId}/all-data
   * @secure
   */
  fieldsGetAllFieldDataForCompany = (companyId: string, params: RequestParams = {}) =>
    this.http.request<FieldInfo[], any>({
      path: `/geology/Fields/for_company/${companyId}/all-data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fields
   * @summary Получение информации о месторождении по идентификатору
   * @request GET:/geology/Fields/{fieldId}
   * @secure
   */
  fieldsGetFieldDetails = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<FieldInfo, any>({
      path: `/geology/Fields/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
